import { type CreateLegalEntityApiPayload } from '../api-models/LegalEntityApiModel'
import { type UpdateLegalEntityInput } from '../types/UpdateLegalEntityInput'

export const mapUpdateLegalEntityInputToApiPayload = (
  input: UpdateLegalEntityInput
): CreateLegalEntityApiPayload => ({
  name: input.name.trim(),
  base_currency: input.baseCurrencyId,
  country: input.country?.trim() ?? '',
  external_id: input.externalId?.trim() ?? '',
})
